import { Analytics } from '@cobliteam/analytics';
import BaseButton, { type ButtonProps } from '@cobliteam/ui/components/Button';
import Icon, { type IconNames } from '@cobliteam/ui/icons';
import { useHistory } from 'react-router-dom';
import { isFilled, type KeyTextField } from '../index';
import type { LoginPageDocumentDataButtonsItem } from '../types/herbie-dashboard.generated';

type PrismicButtonType = ButtonProps & {
  button: LoginPageDocumentDataButtonsItem;
  idx?: number;
  analytics_track?: KeyTextField;
};

export function PrismicButton({ button, idx, analytics_track }: PrismicButtonType) {
  const history = useHistory();

  const handleClick = () => {
    analytics_track && Analytics.track(analytics_track);
    isFilled.link(button.link) &&
      button.link.link_type === 'Web' &&
      (button.link.target === '_blank' ? window.open(button.link.url, button.link.target) : history.push(button.link.url));
  };

  return (
    <BaseButton
      key={idx}
      startIcon={isFilled.select(button.left_icon) && <Icon name={button.left_icon as IconNames} />}
      endIcon={isFilled.select(button.right_icon) && <Icon name={button.right_icon as IconNames} />}
      variant={button.variant as ButtonProps['variant']}
      color={button.color as ButtonProps['color']}
      size={button.size as ButtonProps['size']}
      onClick={handleClick}
    >
      {button.label}
    </BaseButton>
  );
}
